import React, { ReactNode } from 'react';
import {
  CasesProvider,
  CaseData,
} from '../../contexts/api-contexts/CasesContext';
import { SymptomsProvider } from '../../contexts/api-contexts/SymptomsContext';
import { AnimalTypeProvider } from '../../contexts/api-contexts/AnimalTypeContext';
import { BreedsProvider } from '../../contexts/api-contexts/BreedsContext';
import { DiseasesProvider } from '../../contexts/api-contexts/DiseasesContext';
import { CaseAttachmentProvider } from '../../contexts/api-contexts/CaseAttachmentContext';
import { TreatmentsProvider } from '../../contexts/api-contexts/TreatmentsContext';
import { SoapNotesProvider } from '../../contexts/api-contexts/SoapNotesContext';

interface CasesProvidersProps {
  children: ReactNode;
  case?: CaseData;
}

/**
 * CasesProviders - A wrapper component that provides all the necessary contexts
 * for cases functionality. This includes AnimalTypeProvider, BreedsProvider,
 * SymptomsProvider, DiseasesProvider, TreatmentsProvider, CasesProvider,
 * and CaseAttachmentProvider.
 *
 * Use this when you need to provide case contexts but want to handle
 * navigation and layout yourself.
 */
export const CasesProviders: React.FC<CasesProvidersProps> = ({
  children,
  case: initialCase,
}) => {
  return (
    <AnimalTypeProvider>
      <BreedsProvider>
        <SymptomsProvider>
          <DiseasesProvider>
            <TreatmentsProvider>
              <CasesProvider case={initialCase}>
                <CaseAttachmentProvider>
                  <SoapNotesProvider>{children}</SoapNotesProvider>
                </CaseAttachmentProvider>
              </CasesProvider>
            </TreatmentsProvider>
          </DiseasesProvider>
        </SymptomsProvider>
      </BreedsProvider>
    </AnimalTypeProvider>
  );
};

export default CasesProviders;
